import React from "react";

type PageTitleProps = {
  text: string;
  children?: React.ReactNode;
  variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  className?: string;
  props?: any;
  icon?: React.ReactNode;
  topText?: React.ReactNode;
  noMargin?: boolean;
};

import { PageTitleContainer } from "./styles";

const PageTitle = ({
  text,
  children,
  variant = "h1",
  className,
  props,
  icon,
  topText,
  noMargin = false,
}: PageTitleProps) => {
  const Component = variant;

  return (
    <PageTitleContainer $noMargin={noMargin}>
      {topText && <span className="top-text">{topText}</span>}
      <Component className={`${className || ""}`} {...props}>
        {icon && <span className="page-title-icon">{icon}</span>}
        {text}
      </Component>
      {children && <p>{children}</p>}
    </PageTitleContainer>
  );
};

export default PageTitle;
